import styleme from '../img/styleme.png';
import slay from '../img/slay.png';
import learnlocker from '../img/learnlocker.png';

export const projects = [
  {
    category: 'personal',
    title: 'Style Me AI',
    image: styleme,
    description:
      'An AI-powered styling assistant that generates outfit and makeup recommendations based on your closet, the occasion, weather, and personal style.',
    view: 'https://www.linkedin.com/posts/sumayyahasgar_closetos-doesnt-just-style-your-clothes-activity-7419237844193517568-oaEi?utm_source=share&utm_medium=member_desktop&rcm=ACoAACXbvMgB7GO8PuB_dJdRiJMQD3frfQbQUzA',
    source: 'https://github.com/sumi419'
  },
  {
    category: 'personal',
    title: 'Slay All Day',
    image: slay,
    description:
      'A web app that lets users search makeup products across multiple shopping sites in one place.',
    view: 'https://sumi419.github.io/highlight/',
    source: 'https://github.com/sumi419/highlight'
  },
  {
    category: 'capstone',
    title: 'LearnLocker',
    image: learnlocker,
    description:
      'A platform that helps users track courses and articles while discovering what others are learning.',
    view: 'https://learnlocker.dev',
    source: 'https://github.com/learneda'
  }
];
